import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {SecurityContext} from './security-context';

@Injectable({
    providedIn: 'root'
})
export class AnonymousGuardService implements CanActivate {
    private router = inject(Router);
    private securityContext = inject(SecurityContext);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.securityContext.isAuthenticated()) {
            this.router.navigate(['']);
            return false;
        }
        return true;
    }

}
